import {
  createContext,
  type Dispatch,
  type SetStateAction,
  useContext,
} from "react";

import type { FlightSearchFormValues } from "@/features/flights/utils/flightsValidation";

export interface FlightSearchDataContextValue {
  searchData: FlightSearchFormValues | null;
  updateSearchData: Dispatch<SetStateAction<FlightSearchFormValues | null>>;
}

export const FlightSearchDataContext =
  createContext<FlightSearchDataContextValue | null>(null);

export const useFlightSearchDataContext = () => {
  const context = useContext(FlightSearchDataContext);
  if (!context) {
    throw new Error(
      "useFlightSearchDataContext must be used within a FlightSearchDataProvider",
    );
  }
  return context;
};
